import React from 'react';

import { Modal } from '../common/Modal';

import { FormattedMessage } from 'react-intl';
import { OnboardingStep1 } from 'src/easyclaim.app.assets';
import styled, { css } from 'styled-components';

import { FadeIn } from '..';
import { ProductType, EasyClaimCaseResponseDto } from '../../easyclaim.api.client.typescript/src';
import {} from '../../easyclaim.api.client.typescript/src/index';
import FormattedHtmlMessage from '../common/FormattedHtmlMessage';

interface TutorialModalProps {
	isOpen: boolean;
	onClose: () => void;
	easyClaimCase?: EasyClaimCaseResponseDto;
}
export class TutorialModal extends React.Component<TutorialModalProps, {}> {
	render() {
		const configuration = this.props.easyClaimCase && this.props.easyClaimCase._configuration;

		return (
			<Modal
				isOpen={this.props.isOpen}
				closeOnBackdropClick={true}
				onClose={this.props.onClose}
				header={
					<h2>
						{configuration?.layout === ProductType.PolicyCheck ? (
							<FormattedMessage id="tutorialModal.headline.first.policyCheck" />
						) : (
							<FormattedMessage id="tutorialModal.headline.first" />
						)}
					</h2>
				}
			>
				<>
					{this.props.isOpen && (
						<div className="tutorialModal-artwork-container">
							<OnboardingCarImage />
						</div>
					)}
					<Paragraph>
						{configuration?.layout === ProductType.PolicyCheck ? (
							<FormattedHtmlMessage id="tutorialModal.paragraph.first.policyCheck" />
						) : (
							<FormattedMessage id="tutorialModal.paragraph.first" />
						)}

						<br />
						<br />
						<FormattedMessage id="tutorialModal.paragraph.second" />
					</Paragraph>
				</>
			</Modal>
		);
	}
}

const OnboardingCarImage = styled(OnboardingStep1)`
	/* width: 100%;
	max-width: 500px;
	height: auto; */
	max-height: 250px;
	display: block;
	margin: 0 auto;
	animation: ${css`
			${FadeIn}`} 2s both;
	& svg text {
		font-size: unset;
	}
`;

const Paragraph = styled.p`
	text-align: left;
`;
